const storeTypes = {
  PARTNER_AS_EXECUTOR:"PARTNER_AS_EXECUTOR",
  SET_EXECUTOR:'SET EXECUTOR',
  SET_COEXECUTOR:'SET CO_EXECUTOR',
  SET_ALT_EXECUTOR:'SET ALT EXECUTOR',

}
export default storeTypes;